const actionTypes = {
    THEME : 'THEME'
};

export default actionTypes;